import { render, staticRenderFns } from "./EditReferences.vue?vue&type=template&id=2d64c5b3&"
import script from "./EditReferences.vue?vue&type=script&lang=ts&"
export * from "./EditReferences.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports